import {combineReducers} from 'redux';
import posts from './posts';
import pages from './pages';
import menu from './menu';
import options from './options';
import projects from './projects';
import projectTransitions from './project-transitions';
import journals from './journals';
import awards from './awards';
import press from './press';

export const rootReducer = combineReducers({posts, pages, menu, options, projects, projectTransitions, journals, awards, press});


// WEBPACK FOOTER //
// ./src/reducers/index.js